const RelatedLinks = ({ links }) => {
  return (
    <div className="mt-4">
      <ul className="flex flex-col gap-2 sm:gap-1">
        {links.map((link, i) => (
          <li key={i} className="inline-block">
            <a
              href={link.to}
              className="text-black hover:text-red-300 underline transition-colors duration-200"
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Footer = () => {
  return (
    <footer className="bg-white text-black px-6 py-12 mt-12 border-t border-gray-800">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {/* Contact Info */}
        <div className="space-y-3 text-center sm:text-left">
          <h3 className="text-xl font-bold text-red-400">Contact</h3>

          <p className="text-base font-medium">
            Telefoonnummer:{" "}
            <a
              href="tel:+32477292333"
              className="text-black underline hover:text-red-300 transition"
            >
              0477 29 23 33
            </a>
          </p>

          <p className="text-base font-medium">Adres: Spijkerswegel 3, 8310 Sint-Kruis</p>

          <p className="text-base font-medium">
            Email:{" "}
            <a
              href="mailto:info@hoeveslagerijdespycker.be"
              className="text-black underline hover:text-red-300 transition"
            >
              info@hoeveslagerijdespycker.be
            </a>
          </p>
        </div>

        {/* Links */}
        <div className="text-center sm:text-left">
          <h3 className="text-xl font-bold text-red-400">Navigatie</h3>
          <RelatedLinks
            links={[
              { to: "/over-ons", label: "Over ons" },
              { to: "/bestellen", label: "Plaats een bestelling" },
              { to: "/foto's", label: "Bekijk foto’s" }
            ]}
          />
        </div>

        {/* Branding */}
        <div className="text-center lg:text-right flex flex-col gap-2">
          <h3 className="text-xl font-bold text-red-400">Hoeveslagerij De Spycker</h3>
          <p className="text-sm text-black">Authentieke kwaliteit, dagvers en lokaal.</p>
        </div>
      </div>

      <div className="mt-10 text-center border-t border-gray-200 pt-6">
        <p className="text-sm text-gray-500">
          © {new Date().getFullYear()} Hoeveslagerij De Spycker
        </p>
        <p className="text-sm text-gray-500">
          Made by{" "}
          <a
            href="https://www.musign.be"
            className="text-red-500 hover:text-red-300 transition"
          >
            Musign
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;